import { Input, Table, Panel } from 'appkit-react';

import ErrorView from '../../../Shared/components/ErrorView';
import Loader from '../../../Shared/components/Loader';
import CreateProjectModal from '../../Projects/CreateProjectModal/CreateProjectModal';
import NestedTable from '../../Projects/NestedTable/NestedTable';
import '../styles/project-list.scss';

const ProjectList = ({
    columns, subColumns, projects, showModal, setShowModal, dataForUpdate, tenantId,
    dataForClone, copyProjectFlag, setCopyProjectFlag, refetch, searchString,
    setSearchString, projectHierarchyIsLoading, projectHierarchyIsError, setToastMessage,
}) => (
    <Panel
        title="PROJECT LIST"
        className="a-increase-child-color-level-by-1"
        renderRight={() => (
            <>
                <div className="search-string">
                    <Input
                        prefix={(
                            <span
                                className="icon-search-outline appkiticon change-color-with-focus"
                                style={{ fontSize: 16 }}
                            />
                        )}
                        inputBoxSize="sm"
                        placeholder="Search"
                        value={searchString}
                        onChange={e => setSearchString(e)}
                        style={{ width: '20rem' }}
                    />
                </div>
            </>
        )}
    >
        <div className="data-recon-home-page-projects-list">

            {projectHierarchyIsLoading && <Loader />}
            {projectHierarchyIsError && <ErrorView />}

            {showModal
                && (
                    <CreateProjectModal
                        visibleFlag={showModal}
                        setShowModal={setShowModal}
                        projectData={dataForUpdate}
                        tenantId={tenantId}
                        dataForClone={dataForClone}
                        copyProjectFlag={copyProjectFlag}
                        setCopyProjectFlag={setCopyProjectFlag}
                        fetchData={refetch}
                        setToastMessage={setToastMessage}
                    />
                )}

            {!projectHierarchyIsLoading && (
                <div style={{ marginTop: '1rem' }}>
                    <Table
                        data={projects || []}
                        columns={columns}
                        defaultPageSize={10}
                        sortable
                        size="lg"
                        resizable
                        className="-striped -highlight ReactTable rt-expander"
                        SubComponent={row => {
                            if (row.original.children.length > 0) {
                                return (
                                    <div style={{ padding: '5px 0 10px 0px' }}>
                                        <NestedTable original={row.original} columns={subColumns} />
                                    </div>
                                );
                            }
                            return <span />;
                        }}
                    />
                </div>
            )}
        </div>
    </Panel>
);

export default ProjectList;
